export class ClientTenant {
    Name: string;
    CreatedBy: string;
}